/* ============================================================
   Foreground / background edges for the client core, from the browser:
     • a tab becoming visible, the window regaining focus, or the network
       coming back → `active` (the store drains its outbox, preferences flush)
     • the tab hiding or the page being unloaded → `background` (the store
       flushes its snapshot — `pagehide` is the last reliable moment)
   ============================================================ */
import type { LifecycleAdapter } from '@habishine/client-core';

export const lifecycle: LifecycleAdapter = {
  subscribe(listener) {
    const onVisibility = () =>
      listener(document.visibilityState === 'visible' ? 'active' : 'background');
    const onActive = () => listener('active');
    const onHide = () => listener('background');
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onActive);
    window.addEventListener('online', onActive);
    window.addEventListener('pagehide', onHide);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onActive);
      window.removeEventListener('online', onActive);
      window.removeEventListener('pagehide', onHide);
    };
  },
};
